import React from "react";
import "./App.css";
import { HashRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Activite from "./components/Activite";
import ActiviteDetail from "./components/ActiviteDetail";
import Realisations from "./components/Realisations";
import Equipe from "./components/Equipe";
import Chiffres from "./components/Chiffres";
import Contact from "./components/Contact";
import LegalMentions from "./components/LegalMentions";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import APropos from "./components/APropos";
import NotFound from "./components/NotFound";
import SEO from "./components/SEO";
import RachatPropriete from "./components/RachatPropriete";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookieBanner from "./components/CookieBanner";
import { activites } from "./mock";

const Layout = ({ children }) => (
  <div className="bg-white min-h-screen text-neutral-900">
    <Navbar />
    <main>{children}</main>
    <Footer />
    <Toaster position="top-right" richColors />
  </div>
);

const AccueilPage = () => (
  <Layout>
    <SEO
      title="Maison Labroca — Construction & Rénovation en Île-de-France"
      description="Maison Labroca, entreprise familiale forte de plus de 40 ans d'expérience : construction de maisons, division de terrains, promotion et rénovation tout corps d'état en Île-de-France."
    />
    <Hero />
    <Activite />
    <Chiffres />
  </Layout>
);

const ActiviteDetailPage = () => {
  const { id } = useParams();
  const activite = activites.find((a) => a.id === id);
  return (
    <Layout>
      <SEO
        title={activite ? `${activite.title} — Maison Labroca` : "Activité — Maison Labroca"}
        description={activite ? activite.text : undefined}
      />
      <ActiviteDetail />
    </Layout>
  );
};

const RealisationsPage = () => (
  <Layout>
    <SEO
      title="Nos réalisations — Maison Labroca"
      description="Découvrez les réalisations de Maison Labroca en Île-de-France : constructions et rénovations, avant/après."
    />
    <Realisations />
  </Layout>
);

const AProposPage = () => (
  <Layout>
    <SEO
      title="À propos — Maison Labroca"
      description="Entreprise familiale fondée en 2004, Maison Labroca accompagne ses clients dans la construction résidentielle et tous types de rénovations en Île-de-France."
    />
    <APropos />
    <Equipe />
  </Layout>
);

const ContactPage = () => (
  <Layout>
    <SEO
      title="Contact — Maison Labroca"
      description="Contactez Maison Labroca pour votre projet de construction ou de rénovation en Île-de-France. Réponse sous 48 heures."
    />
    <Contact />
    <LegalMentions />
    <PrivacyPolicy />
  </Layout>
);

const RachatProprietePage = () => (
  <Layout>
    <SEO
      title="Étude & Rachat de propriété — Maison Labroca"
      description="Vous avez un terrain, une maison, un appartement ou un immeuble à céder ? Maison Labroca étudie chaque opportunité pour d'éventuels projets de construction ou de rénovation."
    />
    <RachatPropriete />
  </Layout>
);

const NotFoundPage = () => (
  <Layout>
    <SEO title="Page introuvable — Maison Labroca" />
    <NotFound />
  </Layout>
);

function App() {
  return (
    <div className="App">
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AccueilPage />} />
          <Route path="/activite/:id" element={<ActiviteDetailPage />} />
          <Route path="/realisations" element={<RealisationsPage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/rachat-de-propriete" element={<RachatProprietePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </HashRouter>
      <CookieBanner />
    </div>
  );
}

export default App;

